<script>
import Base from './TabsBase'

const theme = require('@/helpers/Settings').default.theme

const requireTheme = require.context('./themes/', true)

const Template = requireTheme(`./${theme}/Tabs`).default

let componentTemplates = {
    "vertical": {
        mixins: [
            Base,
            Template,
            requireTheme(`./${theme}/TabsVertical`).default
        ]
    },
    "vertical-right": {
        mixins: [
            Base,
            Template,
            requireTheme(`./${theme}/TabsVerticalRight`).default
        ]
    },
    "horizontal": {
        mixins: [
            Base,
            Template,
            requireTheme(`./${theme}/TabsHorizontal`).default
        ]
    }
}

export default {
    name: 'oc-tabs',
    functional: true,
    props: {
        theme: {
            type: String,
            validator: function (value) {
                return ['vertical', 'vertical-right', 'horizontal'].indexOf(value) !== -1
            },
            default: 'horizontal'
        }
    },
    render(createElement, context) {
        // --------------------------- //
        let template = context.props.theme

        let component = componentTemplates[template]

        component.name = 'oc-tabs'

        // --------------------------- //

        let data = Object.assign(
            {},
            context.data,
            {
                scopedSlots: context.scopedSlots,
                slots: context.slots,
                on: context.listeners
            }
        )

        if( data.attrs === undefined ) {
            data.attrs = {}
        }

        data.attrs = Object.assign({}, data.attrs);

        return createElement(
            component,
            data,
            context.children
        )
    }
}
</script>
